import type { EmbeddedInsertContext } from "@intelligems/ig-types/schemas/plugin/plugin/embedded";
import { createAsyncThunk } from "@src/store";
import { cancelDraft } from "@src/store/slices/experienceBuilder/common/thunks/cancelDraft";
import { componentSlice } from "@src/store/slices/experienceBuilder/component/slice";

export const startInsertion = createAsyncThunk<void, EmbeddedInsertContext>(
  "experienceBuilder/component/startInsertion",
  async (payload, { dispatch }) => {
    const confirmed = await dispatch(cancelDraft()).unwrap();
    if (!confirmed) {
      return;
    }

    dispatch(componentSlice.actions._startInsertion(payload));
  }
);
